import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { ThirdPartyApprovedCompaniesParamList } from '../../../typings/Params';
import FilterCheckBox from '../../../components/Filter/components/FilterCheckBox';
import FilterDatePicker from '../../../components/Filter/components/FilterDateInput';
import moment from 'moment';
import { View } from 'react-native';
// import CamerasThirdPartyImageProviderDropdown from '../../../components/cameras/CamerasThirdPartyImageProviderDropdown';
// import CamerasThirdPartyCloudProviderDropdown from '../../../components/cameras/CamerasThirdPartyCloudProviderDropdown';
// import CameraTypeDropdown from '../../cameras/Cameras/CameraTypeDropdown';
import CamerasThirdPartyOriginDropdown from '../../../components/cameras/CamerasThirdPartyOriginDropdown';
import IntegrationTypesSelector from '../../../components/Filters/Cameras/IntegrationTypesSelector';
import AlgorithmDropdown from '../../../components/AlgorithmDropdown';
import { AlgorithmFilter } from '../../../schemas/cameras';

interface Props {
    filters: ThirdPartyApprovedCompaniesParamList['DonatedCamerasList'];
    setFilters: React.Dispatch<React.SetStateAction<ThirdPartyApprovedCompaniesParamList['DonatedCamerasList']>>;
    textFilter: string;
    setTextFilter: React.Dispatch<React.SetStateAction<string>>;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<ThirdPartyApprovedCompaniesParamList, 'DonatedCamerasList'>>>();

    const [beginInDateFilter, setBeginInDateFilter] = useState(filters.beginIn ? new Date(filters.beginIn) : null);
    const [beginInHourFilter, setBeginInHourFilter] = useState(filters.beginIn ? moment(filters.beginIn).format('HH:mm') : '');
    // const [selectedCameraTypeFilter, setSelectedCameraTypeFilter] = useState<CameraType | 'all'>(filters.cameraType ?? 'all');
    const [showRejectedFilter, setShowRejectedFilter] = useState(filters.showRejected ?? false);
    const [showRemovedByThirdParty, setShowRemovedByThirdParty] = useState(filters.showRemovedByThirdParty ?? false);
    const [selectedIntegrationTypeFilter, setSelectedIntegrationTypeFilter] = useState<('type_2' | 'type_3')[]>(filters.integrationType ?? []);
    const [selectedThirdPartyOrigin, setSelectedThirdPartyOrigin] = useState<string>(filters.origin ?? '');
    const [selectedAlgorithmFilter, setSelectedAlgorithmFilter] = useState<AlgorithmFilter | 'all'>('all');
    // TODO: Add when migrated to thirdPartyApprovedCompanies
    // const [selectedThirdPartyImageProvider, setSelectedThirdPartyImageProvider] = useState<string>(filters.imageProvider ?? '');
    // const [selectedThirdPartyCloudProvider, setSelectedThirdPartyCloudProvider] = useState<string>(filters.cloudProvider ?? '');

    const handleCleanFilter = () => {
        setTextFilter('');
        setSelectedIntegrationTypeFilter([]);
        setShowRejectedFilter(false);
        setShowRemovedByThirdParty(false);
        setBeginInDateFilter(null);
        setBeginInHourFilter('');
        setSelectedThirdPartyOrigin('');
        setSelectedAlgorithmFilter('all');
        // setSelectedThirdPartyImageProvider('');
        // setSelectedThirdPartyCloudProvider('');
        // setSelectedCameraTypeFilter('all');
    };

    const handleFilter = () => {
        const formatDateTime = (date: Date | null, time: string) =>
            date ? moment(`${moment(date).format('DD/MM/YYYY')} ${time}`, 'DD/MM/YYYY HH:mm:ss').valueOf() : undefined;
        const beginIn = formatDateTime(beginInDateFilter, beginInHourFilter ? `${beginInHourFilter}:00` : '00:00:00');
        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter || undefined,
            integrationType: selectedIntegrationTypeFilter.length > 0 ? selectedIntegrationTypeFilter : undefined,
            origin: selectedThirdPartyOrigin.trim() !== '' ? selectedThirdPartyOrigin : undefined,
            showRejected: showRejectedFilter ? showRejectedFilter : undefined,
            showRemovedByThirdParty: showRemovedByThirdParty ? showRemovedByThirdParty : undefined,
            beginIn: beginIn && !isNaN(beginIn) ? beginIn : undefined,
            hasFacial: selectedAlgorithmFilter === 'hasFacial' || undefined,
            hasLpr: selectedAlgorithmFilter === 'hasLpr' || undefined,
            // imageProvider: selectedThirdPartyImageProvider != '' ? selectedThirdPartyImageProvider : undefined,
            // cloudProvider: selectedThirdPartyCloudProvider != '' ? selectedThirdPartyCloudProvider : undefined,
            // cameraType: selectedCameraTypeFilter !== 'all' ? selectedCameraTypeFilter : undefined,
        });

        navigation.setParams({
            page: 1,
            textFilter: textFilter || undefined,
            integrationType: selectedIntegrationTypeFilter.length > 0 ? selectedIntegrationTypeFilter : undefined,
            origin: selectedThirdPartyOrigin.trim() !== '' ? selectedThirdPartyOrigin : undefined,
            showRejected: showRejectedFilter ? showRejectedFilter : undefined,
            showRemovedByThirdParty: showRemovedByThirdParty ? showRemovedByThirdParty : undefined,
            beginIn: beginIn && !isNaN(beginIn) ? beginIn : undefined,
            hasFacial: selectedAlgorithmFilter === 'hasFacial' || undefined,
            hasLpr: selectedAlgorithmFilter === 'hasLpr' || undefined,
            // imageProvider: selectedThirdPartyImageProvider != '' ? selectedThirdPartyImageProvider : undefined,
            // cloudProvider: selectedThirdPartyCloudProvider != '' ? selectedThirdPartyCloudProvider : undefined,
            // cameraType: selectedCameraTypeFilter !== 'all' ? selectedCameraTypeFilter : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />
            <View style={{ flexDirection: 'column', rowGap: 8 }}>
                <FilterCheckBox
                    label={translate('rejectedCameras')}
                    value={showRejectedFilter}
                    onChange={setShowRejectedFilter}
                />
                <FilterCheckBox
                    label={translate('cameraRemovedByThirdParty')}
                    value={showRemovedByThirdParty}
                    onChange={setShowRemovedByThirdParty}
                />
            </View>
            {/* <CameraTypeDropdown
                value={selectedCameraTypeFilter}
                setValue={setSelectedCameraTypeFilter}
                includeAll={true}
                zIndex={7}
            /> */}
            <FilterDatePicker
                date={beginInDateFilter}
                onChangeDate={setBeginInDateFilter}
                time={beginInHourFilter}
                onChangeTime={setBeginInHourFilter}
                label={translate('createdAt')}
                zIndex={6}
            />
            <IntegrationTypesSelector
                value={selectedIntegrationTypeFilter}
                setValue={setSelectedIntegrationTypeFilter}
            />
            <CamerasThirdPartyOriginDropdown
                value={selectedThirdPartyOrigin}
                setValue={setSelectedThirdPartyOrigin}
                integrationType={'all'}
                zIndex={2}
            />
            <AlgorithmDropdown
                value={selectedAlgorithmFilter}
                setValue={setSelectedAlgorithmFilter}
                zIndex={1}
                required={false}
                disabled={false}
                excludeAreaInvasion
            />
            {/* <CamerasThirdPartyImageProviderDropdown
                value={selectedThirdPartyImageProvider}
                setValue={setSelectedThirdPartyImageProvider}
                zIndex={2}
            />
            <CamerasThirdPartyCloudProviderDropdown
                value={selectedThirdPartyCloudProvider}
                setValue={setSelectedThirdPartyCloudProvider}
                zIndex={1}
            /> */}
        </Filters>
    );
}


export default Filter;
